export const eleData = {
  "child1": {
    "w": 123,
    "h": 314
  },
  "child2": {
    "w": 120,
    "h": 293
  },
  "child3": {
    "w": 88,
    "h": 76
  },
  "child4": {
    "w": 67,
    "h": 116
  },
  "pet1": {
    "w": 206,
    "h": 217
  },
  "pet2": {
    "w": 226,
    "h": 217
  },
  "pet3": {
    "w": 165,
    "h": 147
  },
  "pet4": {
    "w": 230,
    "h": 190
  },
  "pet5": {
    "w": 79,
    "h": 184
  },
  "pet6": {
    "w": 170,
    "h": 130
  },
  "pet7": {
    "w": 183,
    "h": 189
  },
  "pet8": {
    "w": 191,
    "h": 196
  },
  "pet9": {
    "w": 186,
    "h": 127
  },
  "pet10": {
    "w": 194,
    "h": 142
  },
  "coup11": {
    "w": 750,
    "h": 830
  },
  "coup12": {
    "w": 750,
    "h": 830
  },
  "coup13": {
    "w": 750,
    "h": 830
  },
  "coup14": {
    "w": 750,
    "h": 830
  },
  "coup21": {
    "w": 750,
    "h": 830
  },
  "coup22": {
    "w": 750,
    "h": 830
  },
  "coup23": {
    "w": 750,
    "h": 830
  },
  "coup24": {
    "w": 750,
    "h": 830
  },
  "coup31": {
    "w": 750,
    "h": 830
  },
  "coup32": {
    "w": 750,
    "h": 830
  },
  "coup33": {
    "w": 750,
    "h": 830
  },
  "coup34": {
    "w": 750,
    "h": 830
  },
  "coup41": {
    "w": 750,
    "h": 830
  },
  "coup42": {
    "w": 750,
    "h": 830
  },
  "coup43": {
    "w": 750,
    "h": 830
  },
  "coup44": {
    "w": 750,
    "h": 830
  },
  "youngM1c": {
    "w": 180,
    "h": 435
  },
  "youngM2c": {
    "w": 184,
    "h": 434
  },
  "youngM3c": {
    "w": 208,
    "h": 428
  },
  "youngM4c": {
    "w": 164,
    "h": 442
  },
  "youngM5c": {
    "w": 177,
    "h": 460
  },
  "youngM6c": {
    "w": 192,
    "h": 442
  },
  "youngM1h": {
    "w": 78,
    "h": 100
  },
  "youngM2h": {
    "w": 58,
    "h": 82
  },
  "youngM3h": {
    "w": 55,
    "h": 85
  },
  "youngM4h": {
    "w": 59,
    "h": 83
  },
  "youngM5h": {
    "w": 65,
    "h": 88
  },
  "youngM6h": {
    "w": 70,
    "h": 88
  },
  "youngF1c": {"w":155,"h":407},
  "youngF2c": {"w":155,"h":413},
  "youngF3c": {"w":180,"h":420},
  "youngF4c": {"w":190,"h":532},
  "youngF5c": {"w":146,"h":538},
  "youngF6c": {"w":137,"h":400},
  "youngF1h": {
    "w": 90,
    "h": 90
  },
  "youngF2h": {
    "w": 65,
    "h": 90
  },
  "youngF3h": {"w":80,"h":81},
  "youngF4h": {"w":57,"h":164},
  "youngF5h": {"w":63,"h":180},
  "youngF6h": {"w":85,"h":128},
  "parentF1c": {
    "w": 150,
    "h": 471
  },
  "parentF2c": {
    "w": 140,
    "h": 444
  },
  "parentF1h": {
    "w": 80,
    "h": 90
  },
  "parentF2h": {
    "w": 75,
    "h": 110
  },
  "parentM1c": {
    "w": 165,
    "h": 481
  },
  "parentM2c": {
    "w": 175,
    "h": 490
  },
  "parentM1h": {
    "w": 60,
    "h": 92
  },
  "parentM2h": {
    "w": 65,
    "h": 102
  },
  "grandF1c": {
    "w": 192,
    "h": 346
  },
  "grandF2c": {
    "w": 180,
    "h": 357
  },
  "grandF1h": {
    "w": 66,
    "h": 86
  },
  "grandF2h": {
    "w": 68,
    "h": 78
  },
  "grandM1c": {
    "w": 202,
    "h": 400
  },
  "grandM2c": {
    "w": 209,
    "h": 336
  },
  "grandM1h": {
    "w": 60,
    "h": 100
  },
  "grandM2h": {
    "w": 62,
    "h": 120
  },
}
